module.exports = __webpack_public_path__ + "static/img/Online professional education platform.0d28295.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/Online professional education platform.jpg
// module id = 7hah
// module chunks = 1